/*
 * チュートリアルモーダルの表示制御
 * 表示制御には、a11y-dialog(https://github.com/KittyGiraudel/a11y-dialog)を利用している
 */
import A11yDialog from 'a11y-dialog';
import { disableBodyScroll, enableBodyScroll } from '@component_path/lib/body-scroll-lock';

document.addEventListener('DOMContentLoaded', () => {
  const modal_id = document.querySelector('.modal_login').id;
  const modal = new A11yDialog(document.getElementById(modal_id));

  modal.on('show', () => {
    // 背景の位置を固定
    disableBodyScroll();
  });

  modal.on('hide', () => {
    // 背景の位置固定を解除
    enableBodyScroll();
  });

  // モーダルを表示
  modal.show();
});
